// extracted by mini-css-extract-plugin
export default {"FixedSizeVirtualList":"RefsList-module__FixedSizeVirtualList__p13VN0T"};